import Card from '@talkdesk/cobalt-react-card'
import Flex from '@talkdesk/cobalt-react-flex'
import Box from '@talkdesk/cobalt-react-box'
import { Text, Heading } from '@talkdesk/cobalt-react-typography'
import { Icon } from '@talkdesk/cobalt-react-icon'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import * as MFATypes from '../../constants/mfa.types'
import * as MFASteps from '../../constants/steps'
import {
  MFA_SELECTOR_RECOVERY_OTP_NAME,
  MFA_SELECTOR_TOTP_NAME,
  MFA_SELECTOR_WEB_AUTHN_NAME,
  MFA_SELECTOR_RECOVERY_OTP_DESCRIPTION,
  MFA_SELECTOR_TOTP_DESCRIPTION,
  MFA_SELECTOR_WEB_AUTHN_DESCRIPTION
} from '../../constants/ui.labels'

const getMFAInfoFromType = (mfaType, theme) => {
  return {
    [MFATypes.WEB_AUTH]: {
      name: MFA_SELECTOR_WEB_AUTHN_NAME,
      description: MFA_SELECTOR_WEB_AUTHN_DESCRIPTION,
      icon: 'security_key',
      color: theme.primary600
    },
    [MFATypes.TOTP]: {
      name: MFA_SELECTOR_TOTP_NAME,
      description: MFA_SELECTOR_TOTP_DESCRIPTION,
      icon: 'phonelink_lock',
      color: theme.green600
    },
    [MFATypes.RECOVERY_OTP]: {
      name: MFA_SELECTOR_RECOVERY_OTP_NAME,
      description: MFA_SELECTOR_RECOVERY_OTP_DESCRIPTION,
      icon: 'vpn_key',
      color: theme.orange600
    }
  }[mfaType.toUpperCase()]
}

const MFACard = ({ mfaType, selectMFA, changeStep }) => {
  const theme = useTheme()
  const mfaInfo = getMFAInfoFromType(mfaType, theme)

  return (
    <Box paddingBottom={2}>
      <Card
        onClick={() => {
          selectMFA(mfaType)
          changeStep(MFASteps.MFA)
        }}
      >
        <Flex padding={4} alignY="center" alignX="space-between">
          <Flex alignY="center" gap={3}>
            <Icon name={mfaInfo.icon} size="medium" color={mfaInfo.color} />
            <Flex direction="column">
              <Heading level={5}>{mfaInfo.name}</Heading>
              <Text color={theme.gray600}>{mfaInfo.description}</Text>
            </Flex>
          </Flex>
          <Icon name="chevron_right" size="small" color={theme.gray400} />
        </Flex>
      </Card>
    </Box>
  )
}

export default MFACard
